import 'css-chunksrc/client/common/filterMenu/projects/project/styles.scss';export default {
  "project": "_project_1p8aq_1",
  "name": "_name_1p8aq_11"
};